import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {useEffect, useState} from 'react';
import {GetUserRestriction, UpdateUserRestriction} from '../../../../reduxToolkit/restrictions/RestrictionApi';

const UserRestrictionApp = () => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const contractorId = sessionStorage.getItem('contractorId');
    const supplierId = sessionStorage.getItem('providerId');
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const { getUserRestriction } = useSelector((state) => state?.RestrictionSlice);

    const [extraDataSupplier, setExtraDataSupplier] = useState(null);
    const [extraDataContractor, setExtraDataContractor] = useState(null);
    const [extraDataEmployee, setExtraDataEmployee] = useState(null);
    //useState - Send Email
    const [sendEmailWhenCreateContractor, setSendEmailWhenCreateContractor] = useState(false);
    const [sendEmailWhenCreateEmployee, setSendEmailWhenCreateEmployee] = useState(false);
    const [sendEmailWhenCreateSupplier, setSendEmailWhenCreateSupplier] = useState(false);
    const [sendEmailWhenUpdateContractor, setSendEmailWhenUpdateContractor] = useState(false);
    const [sendEmailWhenUpdateEmployee, setSendEmailWhenUpdateEmployee] = useState(false);
    const [sendEmailWhenUpdateSupplier, setSendEmailWhenUpdateSupplier] = useState(false);
    const [livenessEmployee, setLivenessEmployee] = useState(false);
    const [validationEmployee, setValidationEmployee] = useState(false);
    const [biometricEmployee, setBiometricEmployee] = useState(false);
    const [livenessContractor, setLivenessContractor] = useState(false);
    const [validationContractor, setValidationContractor] = useState(false);
    const [biometricContractor, setBiometricContractor] = useState(false);
    const [livenessSupplier, setLivenessSupplier] = useState(false);
    const [validationSupplier, setValidationSupplier] = useState(false);
    const [biometricSupplier, setBiometricSupplier] = useState(false);
    const [livenessVisitor, setLivenessVisitor] = useState(false);
    const [validationVisitor, setValidationVisitor] = useState(false);
    const [biometricVisitor, setBiometricVisitor] = useState(false);

    useEffect(() => {
        if(!getUserRestriction?.id) dispatch(GetUserRestriction());
    }, [getUserRestriction]);

    // while update
    useEffect(() => {
        setExtraDataEmployee(getUserRestriction?.extraDataEmployee);
        setExtraDataSupplier(getUserRestriction?.extraDataSupplier);
        setExtraDataContractor(getUserRestriction?.extraDataContractor);
        setSendEmailWhenCreateEmployee(getUserRestriction?.sendEmailWhenCreateEmployee);
        setSendEmailWhenUpdateEmployee(getUserRestriction?.sendEmailWhenUpdateEmployee);
        setSendEmailWhenCreateContractor(getUserRestriction?.sendEmailWhenCreateContractor);
        setSendEmailWhenUpdateContractor(getUserRestriction?.sendEmailWhenUpdateContractor);
        setSendEmailWhenCreateSupplier(getUserRestriction?.sendEmailWhenCreateSupplier);
        setSendEmailWhenUpdateSupplier(getUserRestriction?.sendEmailWhenUpdateSupplier);
        //her
        setLivenessEmployee(getUserRestriction?.livenessEmployee);
        setValidationEmployee(getUserRestriction?.validationEmployee);
        setBiometricEmployee(getUserRestriction?.biometricEmployee);
        setLivenessContractor(getUserRestriction?.livenessContractor);
        setValidationContractor(getUserRestriction?.validationContractor);
        setBiometricContractor(getUserRestriction?.biometricContractor);
        setLivenessSupplier(getUserRestriction?.livenessSupplier);
        setValidationSupplier(getUserRestriction?.validationSupplier);
        setBiometricSupplier(getUserRestriction?.biometricSupplier);
        setLivenessVisitor(getUserRestriction?.livenessVisitor);
        setValidationVisitor(getUserRestriction?.validationVisitor);
        setBiometricVisitor(getUserRestriction?.biometricVisitor);
    }, [getUserRestriction?.id]);

    // functions
    const clearAllCheck = () => {
        setExtraDataEmployee(false);
        setExtraDataSupplier(false);
        setExtraDataContractor(false);
        setSendEmailWhenCreateContractor(false);
        setSendEmailWhenCreateEmployee(false);
        setSendEmailWhenCreateSupplier(false);
        setSendEmailWhenUpdateContractor(false);
        setSendEmailWhenUpdateEmployee(false);
        setSendEmailWhenUpdateSupplier(false);
        setLivenessEmployee(false);
        setValidationEmployee(false);
        setBiometricEmployee(false);
        setLivenessContractor(false);
        setValidationContractor(false);
        setBiometricContractor(false);
        setLivenessSupplier(false);
        setValidationSupplier(false);
        setBiometricSupplier(false);
        setLivenessVisitor(false);
        setValidationVisitor(false);
        setBiometricVisitor(false);
    };
    // update
    const handelUpdate = () => {
        const data = {
            extraDataEmployee,
            extraDataSupplier,
            extraDataContractor,
            id: getUserRestriction?.id,
            sendEmailWhenCreateContractor,
            sendEmailWhenCreateEmployee,
            sendEmailWhenCreateSupplier,
            sendEmailWhenUpdateContractor,
            sendEmailWhenUpdateEmployee,
            sendEmailWhenUpdateSupplier,
            livenessEmployee,
            validationEmployee,
            biometricEmployee,
            livenessContractor,
            validationContractor,
            biometricContractor,
            livenessSupplier,
            validationSupplier,
            biometricSupplier,
            livenessVisitor,
            validationVisitor,
            biometricVisitor,
        };
        dispatch(UpdateUserRestriction(data)).then(({ payload: { data: { success } } }) => {
            if(success){
                dispatch(GetUserRestriction());
            }
        });
    };

    return {t,DEV,contractorId, supplierId,permission,navigate,
        extraDataSupplier,
        setExtraDataSupplier,
        extraDataContractor,
        setExtraDataContractor,
        extraDataEmployee,
        setExtraDataEmployee,

        sendEmailWhenCreateContractor,
        setSendEmailWhenCreateContractor,
        sendEmailWhenCreateEmployee,
        setSendEmailWhenCreateEmployee,
        sendEmailWhenCreateSupplier,
        setSendEmailWhenCreateSupplier,
        sendEmailWhenUpdateContractor,
        setSendEmailWhenUpdateContractor,
        sendEmailWhenUpdateEmployee,
        setSendEmailWhenUpdateEmployee,
        sendEmailWhenUpdateSupplier,
        setSendEmailWhenUpdateSupplier,

        livenessEmployee,
        setLivenessEmployee,
        validationEmployee,
        setValidationEmployee,
        biometricEmployee,
        setBiometricEmployee,

        livenessContractor,
        setLivenessContractor,
        validationContractor,
        setValidationContractor,
        biometricContractor,
        setBiometricContractor,

        livenessSupplier,
        setLivenessSupplier,
        validationSupplier,
        setValidationSupplier,
        biometricSupplier,
        setBiometricSupplier,

        livenessVisitor,
        setLivenessVisitor,
        validationVisitor,
        setValidationVisitor,
        biometricVisitor,
        setBiometricVisitor,
        clearAllCheck,handelUpdate
    };
};

export default UserRestrictionApp;
